import React, { useEffect, useState, useContext, useRef } from 'react';
import FormContext from '../../helpers/formContext';
import RenderErrors from '../elements/RenderErrors';

export default function PaymentTypes(){
    const {
        inputChange,
        form_data,
        site_options,
        errors,
        RenderErrors,
        selectPaymentType
    } = useContext(FormContext);
    let buttons = []

    buttons = Object.entries(site_options.payment_types).map(([index, data]) => {
        let is_selected = '';
        if(form_data.payment_type == data.value){
            is_selected = 'checked';
        }
        
        return (
            <div className="rb-list-item" key={`payment-types-${index}`}>
                <input type="radio" name="payment_type" defaultChecked={is_selected} onClick={(e) => selectPaymentType(data.value)} />
                <span className="rb-list-label">{data.type_name}</span>
            </div>
        )
    });
    
    if(Object.keys(site_options.payment_types).length > 1){
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="rbuttons">
                        {buttons}
                    </div>
                </div>
            </div>
        )
    }
}